import React, { Component } from 'react'
import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect
} from 'react-router-dom'
import './App.css'
import Contact from './Contact'
import Projects from './Projects'
import { ClipLoader } from 'react-spinners'
import { techs } from './projectData'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faEnvelope,
  faCode,
  faWindowRestore,
  faFileAlt
} from '@fortawesome/free-solid-svg-icons'
import AboutMe from './AboutMe'

class App extends Component {
  state = {
    didScrollToTechDivs: false,
    anim: {
      intro: false,
      myTitle: false,
      icons: false
    },
    nav: '',
    myName: ''
  }

  componentDidMount() {
    this.handleJumboLoad()
    library.add(faEnvelope, faWindowRestore, faCode, faFileAlt)
    window.addEventListener('scroll', this.calcScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.calcScroll)
  }

  calcScroll = () => {
    const techHeight = this.techDiv.getBoundingClientRect().top
    const hdr = this.intro.clientHeight

    const scrollPos = window.scrollY

    if (scrollPos > hdr) {
      this.setState({ nav: 'nav-scrolled', me: 'about-me-scrolled' })
    } else {
      this.setState({ nav: '', me: '' })
    }

    if (
      window.innerHeight > techHeight + 100 &&
      this.state.didScrollToTechDivs == false
    ) {
      this.loopTechDivs(0)
      this.state.didScrollToTechDivs = true
    }
  }

  changeAnimState = id => {
    this.setState({ anim: { ...this.state.anim, [id]: true } })
  }

  handleJumboLoad = () => {
    this.changeAnimState('intro')
    setTimeout(() => {
      this.loopName(0)
    }, 1000)

    setTimeout(() => {
      this.changeAnimState('myTitle')
    }, 2000)

    setTimeout(() => {
      this.changeAnimState('icons')
    }, 3000)
  }

  loopTechDivs(index) {
    if (index < techs.length) {
      const tech = techs[index]
      this.setState({ [tech]: 'anim' })
      setTimeout(() => {
        this.loopTechDivs(index + 1)
      }, 75)
    }
  }

  loopName(index) {
    const self = this
    const name = 'Mark Moeller'
    const nameArr = name.split('')

    if (index < nameArr.length) {
      const blockId = nameArr[index]
      const newText = this.state.myName + blockId
      this.setState({ myName: newText })
      setTimeout(function() {
        self.loopName(index + 1)
      }, 75)
    }
  }

  render() {
    const techDivs = techs.map(techDiv => {
      return <div className={`techDiv ${this.state[techDiv]}`}>{techDiv}</div>
    })

    const intro = this.state.anim.intro ? 'anim' : ''
    const myTitle = this.state.anim.myTitle ? 'anim' : ''
    const icons = this.state.anim.icons ? 'anim' : ''

    return (
      <Router>
        <div className="routerContainer">
          <div
            id="home"
            className={`intro ${intro}`}
            ref={intro => (this.intro = intro)}
          >
            <h1 className="myName">{this.state.myName}</h1>
            <h4 className={`myTitle ${myTitle}`}>Full Stack Web Developer</h4>
            <div className={`icons ${icons}`}>
              <a
                className="iconSpace"
                href="https://github.com/mjm5vp"
                target="_blank"
              >
                <img src="/images/github-logo.png" alt="github" />
              </a>
              <a
                className="iconSpace"
                href="https://www.facebook.com/mark.moeller.56"
                target="_blank"
              >
                <img src="/images/facebook-logo.png" alt="facebook" />
              </a>
              <a
                className="iconSpace"
                href="https://www.linkedin.com/in/mark-moeller-9b721b84/"
                target="_blank"
              >
                <img src="/images/linkedin-logo.png" alt="linkedin" />
              </a>
            </div>
          </div>

          <div className={`nav ${this.state.nav}`}>
            <div className="nav-item">
              <a className="linkText" href="#home">
                Home
              </a>
            </div>
            <div className="nav-item">
              <a
                className="linkText"
                href="https://www.dropbox.com/s/c0sykzbo18c2vft/MarkMoellerResume2021.pdf?dl=0"
                target="_blank"
              >
                Resume
              </a>
            </div>
            <div className="nav-item">
              <a className="linkText" href="#about">
                About
              </a>
            </div>
            <div className="nav-item">
              <a className="linkText" href="#projects">
                Projects
              </a>
            </div>
            <div className="nav-item">
              <a className="linkText" href="#contact">
                Contact
              </a>
            </div>
          </div>

          <AboutMe />

          <div
            className="about-me-techs"
            ref={techDiv => (this.techDiv = techDiv)}
          >
            {techDivs}
          </div>

          <hr />

          <div id="projects" className="projects">
            <h2>Featured Projects</h2>

            <Projects />
          </div>

          <hr />

          <Contact />
        </div>
      </Router>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js